<!--
 * @Author: your name
 * @Date: 2020-03-24 15:00:14
 * @LastEditTime: 2020-03-31 16:01:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\pages\pdf.vue
 -->
<template>
  <iframe id='iframebox' :src="pdfUrl" width="100%" height="100%">

  </iframe>
</template>
<script>
  export default {
    name: 'Pdf',
    mounted() {
      //this.$route.query.winURL
      this.pdfUrl = this.$route.query.winURL
      const iframebox = document.getElementById('iframebox')
      const deviceWidth = document.documentElement.clientWidth
      const deviceHeight = document.documentElement.clientHeight
      iframebox.style.width = (Number(deviceWidth)) + 'px'
      iframebox.style.height = (Number(deviceHeight)) + 'px'
    },
    components: {

    },
    data() {
      return {
        pdfUrl: "",
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/pdf.vue